import { xzLocal } from "@/until/common"; // 引入 xzLocal 工具来获取用户 token
import accountInformation from "@/views/AccountInformation/index.vue";
import myAccount from "@/views/AccountInformation/children/MyAccount.vue";
import homePage from "@/views/HomePage.vue";
import download from "@/views/Download.vue";
import loginPage from "@/views/LoginPage";
import transaction from "@/views/Transaction/Transaction.vue";
import transactionMn from "@/views/Transaction/TransactionMn.vue";
import accountAssets from "@/views/AccountAssets/index.vue";
import depositCurrency from "@/views/Deposit/deposit.vue";
import deposit from "@/views/Deposit/index.vue";
import withdrawalCurrency from "@/views/Withdrawal/withdrawal.vue";
import withdrawal from "@/views/Withdrawal/index.vue";
import fundsDetails from "@/views/FundsDetails/index.vue";
import fundHistory from "@/views/FundHistory/index.vue";
import fundTransfer from "@/views/AccountInformation/children/FundTransfer.vue";
import historicalOrders from "@/views/AccountInformation/children/HistoricalOrders.vue";

import AgentLayout from "@/views/Agent/Layout.vue";
import AgentDashboard from "@/views/Agent/Dashboard/index.vue";
import AgentAccount from "@/views/Agent/Account/index.vue";
import AgentLinks from "@/views/Agent/Links/index.vue";
import AgentCustomerList from "@/views/Agent/CustomerList/index.vue";
import AgentAccountList from "@/views/Agent/AccountList/index.vue";
import AgentWithdrawDeposit from "@/views/Agent/WithdrawDeposit/index.vue";
import AgentAgentList from "@/views/Agent/AgentList/index.vue";
import AgentTradeRole from "@/views/Agent/TradeRole/index.vue";
import AgentTradeSubGroupRole from "@/views/Agent/TradeRole/sub_group.vue";
import AgentTradeRoleEdit from "@/views/Agent/TradeRole/edit.vue";
import AgentTradeRoleCheck from "@/views/Agent/TradeRole/check.vue";
import AgentCommission from "@/views/Agent/Commission/index.vue";
import AgentTradeHistory from "@/views/Agent/TradeHistory/index.vue";
import AgentPositionList from "@/views/Agent/PositionList/index.vue";

import FollowOrderLayout from "@/views/FollowOrder/Layout.vue";
import FollowOrderAccount from "@/views/FollowOrder/Account/index.vue";
import FollowOrderPosition from "@/views/FollowOrder/Position/index.vue";
import FollowOrderTradeRecord from "@/views/FollowOrder/TradeRecord/index.vue";
import FollowOrderSubscribeRecord from "@/views/FollowOrder/SubscribeRecord/index.vue";
import FollowOrderIncomeDetail from "@/views/FollowOrder/IncomeDetail/index.vue";
import FollowOrderWithdrawRecord from "@/views/FollowOrder/WithdrawRecord/index.vue";
import { re } from "mathjs";

export default [
  {
    //交易网站
    path: "/",
    name: "homePage",
    component: homePage,
    children: [
      {
        path: "/accountInformation/myAccount",
        name: "accountInformation",
        component: accountInformation,
        children: [
          {//认证流程
            path: '/accountInformation/certification',
            name: "certification",
            component: () => import('@/views/AccountInformation/children/Certification.vue')
          },
          {//上传手持身份证
            path: '/accountInformation/selfieHolding',
            name: "selfieHolding",
            component: () => import('@/views/AccountInformation/children/SelfieHolding.vue')
          },
          {//补充地址证明
            path: '/accountInformation/addressFailed',
            name: "addressFailed",
            component: () => import('@/views/AccountInformation/children/AddressFailed.vue')
          },
          {//上传签名
            path: '/accountInformation/submitSign',
            name: "submitSign",
            component: () => import('@/views/AccountInformation/children/SubmitSign.vue')
          },
          {
            //个人信息主页
            path: "/accountInformation/myAccount",
            name: "myAccount",
            component: myAccount,
          },
          {
            path: "/accountInformation/accountAssets",
            name: "accountAssets",
            component: accountAssets,
          },
          {
            //入金
            path: "/accountInformation/depositCurrency",
            name: "depositCurrency",
            component: depositCurrency,
          },
          {
            //入金
            path: "/accountInformation/deposit",
            name: "deposit",
            component: deposit,
          },
          {
            //出金
            path: "/accountInformation/withdrawalCurrency",
            name: "withdrawalCurrency",
            component: withdrawalCurrency,
          },
          {
            //出金
            path: "/accountInformation/withdrawal",
            name: "withdrawal",
            component: withdrawal,
          },
          {
            //资金流水
            path: "/accountInformation/fundsDetails",
            name: "fundsDetails",
            component: fundsDetails,
          },
          {
            //账号资产
            path: "/accountInformation/fundHistory",
            name: "fundHistory",
            component: fundHistory,
          },
          {
            //资金划拨
            path: "/accountInformation/fundTransfer",
            name: "fundTransfer",
            component: fundTransfer,
          },
          {
            //资金记录
            path: "/accountInformation/historicalOrders",
            name: "liveAccount",
            component: historicalOrders,
          },
        ],
      },
      {
        path: "/transaction",
        name: "transaction",
        component: transaction,
      },
      {
        path: "/download",
        name: "download",
        component: download,
      },
      {
        path: "/transactionMn",
        name: "transactionMn",
        component: transactionMn,
      }
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: "/login",
    name: "login",
    component: loginPage,
    meta: {
      headHide: false,
    },
  },
  {
    // 经纪人后台
    path: "/agent",
    name: "agent",
    component: AgentLayout,
    redirect: "/agent/dashboard",
    meta: { requireAuth: true, breadcrumb: 'proxy.text1', parentLink: 'dashboard' }, // 顶级面包屑
    children: [
      {
        path: "dashboard",
        name: "agentDashboard",
        component: AgentDashboard,
        // meta: { requireAuth: true, },
      },
      {
        path: "account",
        name: "agentAccount",
        component: AgentAccount,
        meta: { breadcrumb: "proxy.text24" },
      },
      {
        path: "links",
        name: "agentLinks",
        component: AgentLinks,
        meta: {
          breadcrumb: (route) => {
            // 判断路由参数proxyId是否有值
            if (route.query.proxyId) {
              return ['proxy.text282', 'proxy.text211'];
            } else {
              return ['proxy.text211'];
            }
          },
          parentLink: "agentlist", // 父级链接
        },
      },
      {
        path: "customerlist",
        name: "agentCustomerList",
        component: AgentCustomerList,
        meta: { breadcrumb: "proxy.text283" },
      },
      {
        path: "accountlist",
        name: "agentAccountList",
        component: AgentAccountList,
        meta: {
          breadcrumb: (route) => {
            // 判断路由参数userId是否有值
            if (route.query.userId) {
              return ["proxy.text283", "proxy.text284"];
            }
            return ["proxy.text284"];
          },
          parentLink: "customerlist", // 父级链接
        },
      },
      {
        path: "withdrawdeposit",
        name: "agentWithdrawDeposit",
        component: AgentWithdrawDeposit,
        meta: { breadcrumb: "proxy.text285" },
      },
      {
        path: "agentlist",
        name: "agentAgentList",
        component: AgentAgentList,
        meta: { breadcrumb: "proxy.text282" },
      },
      {
        path: "traderole",
        name: "agentTradeRole",
        component: AgentTradeRole,
        meta: { breadcrumb: "proxy.text229" },
      },
      {
        path: "traderolesubgroup",
        name: "agentTradeSubGroupRole",
        component: AgentTradeSubGroupRole,
        meta: {
          breadcrumb: () => {
            return ['proxy.text229', 'proxy.text298'];
          },
          parentLink: "traderole", // 父级链接
        },
      },
      {
        path: "traderoleedit",
        name: "agentTradeRoleEdit",
        component: AgentTradeRoleEdit,
        meta: {
          breadcrumb: (route) => {
            const parentName = "proxy.text229"; // 从 query 中获取父级名称
            const action = route.query.groupName ? "proxy.text299" : "proxy.text300"; // 判断当前是编辑还是添加
            return [parentName, action];
          },
          parentLink: "traderole", // 父级链接
        },
      },
      {
        path: "traderolecheck",
        name: "agentTradeRoleCheck",
        component: AgentTradeRoleCheck,
        meta: {
          breadcrumb: () => {
            return ['proxy.text229', 'proxy.text311'];
          },
          parentLink: "traderole", // 父级链接
        },
      },
      {
        path: "commission",
        name: "agentCommission",
        component: AgentCommission,
        meta: { breadcrumb: "proxy.text151" },
      },
      {
        path: "tradehistory",
        name: "agentTradeHistory",
        component: AgentTradeHistory,
        meta: {
          breadcrumb: (route) => {
            // 获取route里面的query参数 userId有值是从客户列表进入 FundAccountId有值是从交易账户列表进入 都没有值三种情况
            if (route.query.userId) {
              return ['proxy.text283', 'proxy.text86'];
            } else if (route.query.FundAccountId) {
              return ['proxy.text284', 'proxy.text86'];
            } else {
              return ['proxy.text86'];
            }
          },
          parentLink: (route) => {
            // 获取route里面的query参数 userId有值是从客户列表进入 FundAccountId有值是从交易账户列表进入 都没有值三种情况
            if (route.query.userId) {
              return 'customerlist';
            } else if (route.query.FundAccountId) {
              return 'accountlist';
            } else {
              return null;
            }
          }, // 父级链接
        },
      },
      {
        path: "positionlist",
        name: "agentPositionList",
        component: AgentPositionList,
        meta: {
          breadcrumb: (route) => {
            // 获取route里面的query参数 userId有值是从客户列表进入 FundAccountId有值是从交易账户列表进入 都没有值三种情况
            if (route.query.userId) {
              return ["proxy.text283", "proxy.text141"];
            } else if (route.query.FundAccountId) {
              return ["proxy.text284", "proxy.text141"];
            }
            return ["proxy.text141"];
          },
          parentLink: (route) => {
            // 获取route里面的query参数 userId有值是从客户列表进入 FundAccountId有值是从交易账户列表进入 都没有值三种情况
            if (route.query.userId) {
              return 'customerlist';
            } else if (route.query.FundAccountId) {
              return 'accountlist';
            } else {
              return null;
            }
          }, // 父级链接
        },
      },
    ],
  },
  {
    path: "/followorder",
    name: "followorder",
    component: FollowOrderLayout,
    redirect: "/followorder/account",
    meta: { breadcrumb: "followOrder.text1", requireAuth: true, parentLink: 'account' }, // 顶级面包屑
    children: [
      {
        path: "account",
        name: "followorderaccount",
        component: FollowOrderAccount,
        meta: {
          breadcrumb: 'followOrder.text3',
        },
      },
      {
        path: "position",
        name: "followorderposition",
        component: FollowOrderPosition,
        meta: { breadcrumb: "followOrder.text29" },
      },
      {
        path: "traderecord",
        name: "followordertraderecord",
        component: FollowOrderTradeRecord,
        meta: { breadcrumb: "followOrder.text57" },
      },
      {
        path: "subscriberecord",
        name: "followordersubscriberecord",
        component: FollowOrderSubscribeRecord,
        meta: { breadcrumb: "followOrder.text70" },
      },
      {
        path: "incomedetail",
        name: "followorderincomedetail",
        component: FollowOrderIncomeDetail,
        meta: { breadcrumb: "followOrder.text133" },
      },
      {
        path: "withdrawrecord",
        name: "followorderwithdrawrecord",
        component: FollowOrderWithdrawRecord,
        meta: { breadcrumb: "followOrder.text102" },
      },
    ],
  },

];
